import apiClient from './client';
import type { ActivityEvent } from '../types/activity';

export const activityApi = {
  /**
   * Получить ленту активности для ассистента
   */
  async getByAssistant(
    assistantId: string,
    limit: number = 20,
    offset: number = 0
  ): Promise<ActivityEvent[]> {
    const response = await apiClient.get<ActivityEvent[]>(
      `/assistants/${assistantId}/activity-feed`,
      { params: { limit, offset } }
    );
    return response.data;
  },
};
